module.exports = __webpack_public_path__ + "img/production-p4-desc.8f0e5b5b.png";